import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useConfig } from './config';
import { replacePlaceholder } from '../utils/placeholders/replacePlaceholder';
import { AemReportSeparator, ReportConfig, ReportConfigBase } from '../types/aemDataModels';

type ReplaceSeparator<T extends '\\t' | string> = T extends '\\t' ? '\t' : T;

type VerifiedSeparator = ReplaceSeparator<AemReportSeparator>;

export type VerifiedReportConfig = Omit<ReportConfigBase, 'separator'> & { separator?: VerifiedSeparator };

const useReportConfig = (reportConfig?: ReportConfig): VerifiedReportConfig | null => {
  const globalConfig = useConfig();
  const { uniqueId, contentFragmentType, separator, nameFormat, ...restReportConfig } = reportConfig || {};

  return useMemo(
    () =>
      reportConfig
        ? {
            ...restReportConfig,
            ...(reportConfig && {
              nameFormat: replacePlaceholder(
                { date: dayjs().format(globalConfig?.globalDateFormat) },
                reportConfig.nameFormat,
              ),
            }),
            ...(reportConfig.separator && {
              separator: reportConfig.separator.replace(/\\t/g, '\t') as VerifiedSeparator,
            }),
          }
        : null,
    [reportConfig],
  );
};

export default useReportConfig;
